import { Anchor, Group, Text } from "@mantine/core";
import { Link } from "react-router-dom";
import { IconArrowUpRight } from "@tabler/icons-react";
import { shortHash } from "@/lib/format";
import { entityPath } from "@/routes/paths";
import type { EntityKey } from "@/routes/paths";
import { CopyButton } from "./CopyButton";

/**
 * In-app link to a related entity. Builds the URL from the entity registry so a
 * payment can deep-link to its hold/settlement/SAO etc. Renders an em-dash when
 * the FK is null (the common "not linked" case).
 */
export function RelatedLink({
  entity,
  id,
  label,
  short = true,
  copy = false,
}: {
  entity: EntityKey;
  id: string | null | undefined;
  label?: string;
  short?: boolean;
  copy?: boolean;
}) {
  if (!id) return <Text span c="dimmed">—</Text>;
  const display = label ?? (short ? shortHash(id) : id);
  return (
    <Group gap={4} wrap="nowrap" component="span">
      <Anchor component={Link} to={entityPath(entity, id)} size="sm" ff={label ? undefined : "monospace"}>
        <Group gap={2} wrap="nowrap" component="span">
          {display}
          <IconArrowUpRight size={12} style={{ opacity: 0.6 }} />
        </Group>
      </Anchor>
      {copy ? <CopyButton value={id} /> : null}
    </Group>
  );
}
